var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 0.445312H1.40625C0.630844 0.445312 0 1.07616 0 1.85156V11.3828C0 12.1582 0.630844 12.7891 1.40625 12.7891H6.13119L5.71903 14.6146H3.74169V15.5521H12.2583V14.6146H10.281L9.86881 12.7891H14.5938C15.3692 12.7891 16 12.1582 16 11.3828V1.85156C16 1.07616 15.3692 0.445312 14.5938 0.445312ZM1.40625 1.38281H14.5938C14.8522 1.38281 15.0625 1.59309 15.0625 1.85156V9.35156H0.9375V1.85156C0.9375 1.59309 1.14778 1.38281 1.40625 1.38281ZM8.90772 12.7891L9.31987 14.6146H6.68016L7.09231 12.7891H8.90772ZM14.5938 11.8516H1.40625C1.14778 11.8516 0.9375 11.6413 0.9375 11.3828V10.2891H15.0625V11.3828C15.0625 11.6413 14.8522 11.8516 14.5938 11.8516Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52686 6.61523L7.68264 3.45946L8.34546 4.12227L5.18967 7.27805L4.52686 6.61523Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65137 6.61328L10.8072 3.4575L11.47 4.12032L8.31418 7.27609L7.65137 6.61328Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopWindows);
export default __webpack_public_path__ + "static/media/desktop_windows.90783fada8cf9d0c57221a588e42bac3.svg";
export { ForwardRef as ReactComponent };